import React from 'react';

// import { Container } from './styles';

export default function Signup() {
  return <h1>Signup</h1>;
}
